// Contenuti verticali, schema esteso per pagine /per-chi-e/[vertical]
// Quando il verticale ha il campo "rich: true", viene reso il layout esteso.

export const VERTICALS = {
  "sales-commerciale": {
    key: "sales-commerciale",
    label: "Sales · Commerciale",
    short: "Sales",
    rich: true,
    hero_eyebrow: "Per chi è · Sales",
    seo_title: "Recruiting per figure Sales e Commerciali in Italia",
    meta_description:
      "Lovac trova commerciali, agenti e sales manager anche non in ricerca attiva. Hunting su 10 milioni di profili, selezione reale, primi candidati in 15 giorni.",
    subtitle:
      "Trovare un buon commerciale è diventato uno dei problemi più difficili per le PMI italiane. Non perché non esistano, perché quelli bravi non mandano CV.",
    market: {
      title: "Cosa dicono i numeri sul mercato dei commerciali in Italia.",
      intro:
        "Il mercato delle figure commerciali in Italia è tra i più difficili da navigare per le aziende. I dati lo confermano.",
      numbers: [
        {
          v: "54%",
          l: "Tasso di irreperibilità per operatori commerciali. Una ricerca su due non va a buon fine.",
          src: "Sistema Informativo Excelsior, Unioncamere",
        },
        {
          v: "45%",
          l: "Tasso di irreperibilità per rappresentanti, tra le figure più difficili da reclutare.",
          src: "Sistema Informativo Excelsior, Unioncamere",
        },
        {
          v: "50,5%",
          l: "Quota di assunzioni con difficoltà di reperimento per micro e piccole imprese (media nazionale 47,8%).",
          src: "Confartigianato Imprese su dati Excelsior Unioncamere, 2025",
        },
      ],
      ral: {
        title: "RAL di mercato, dati Michael Page Salary Survey 2025 · Sales & Marketing",
        rows: [
          { k: "Sales Manager · 5–10 anni", v: "65.000–75.000 €", note: "RAL annua lorda, figure con team da gestire" },
          { k: "Area Manager · Export Manager", v: "50.000–70.000 €", note: "5–10 anni di esperienza, mercato Italia ed estero" },
          { k: "Direttore Commerciale", v: "95.000–130.000 €", note: "5–10 anni, variabili e benefit incidono sul totale" },
          { k: "Key Account Manager", v: "oltre 70.000 €", note: "Oltre 10 anni di esperienza su clienti strategici" },
        ],
      },
    },
    problemi: {
      title: "Perché trovare commerciali bravi è così difficile.",
      blocks: [
        {
          title: "I migliori non cercano lavoro",
          body:
            "Un commerciale che produce risultati non è sul mercato. È al lavoro, con un portafoglio clienti costruito negli anni, un piano provvigionale che funziona e nessun motivo urgente per cambiare.\n\nMandare un annuncio su un portale significa ricevere candidature da chi è disponibile, non da chi vale la pena cercare. Sono due mercati diversi.",
        },
        {
          title: "Il settore è inflazionato di mediocrità",
          body:
            "Il mercato dei commerciali è pieno di persone che si presentano bene e producono poco. Capire la differenza richiede tempo, esperienza e un processo di valutazione che va oltre il colloquio.\n\nChi ha già assunto un commerciale sbagliato sa quanto costa in termini di tempo perso, clienti non seguiti e opportunità mancate. Il costo non è solo la fee, è tutto quello che non è stato fatto nel frattempo.",
        },
        {
          title: "La selezione tradizionale non funziona",
          body:
            "Pubblicare un annuncio e aspettare non porta ai profili giusti. Le agenzie generaliste mandano chi è disponibile in quel momento, spesso commerciali in uscita da situazioni difficili, non figure solide in cerca di un progetto migliore.\n\nTrovare un buon commerciale richiede hunting attivo: andare a cercare chi non sta cercando, valutare motivazione e stile di vendita, verificare i risultati reali, non solo quelli dichiarati.",
        },
      ],
    },
    metodo: {
      title: "Come troviamo commerciali che producono davvero.",
      paragraphs: [
        "Il recruiting sales è il nostro core storico. Abbiamo una business unit dedicata esclusivamente alle figure commerciali, recruiter specializzati che lavorano solo su questo segmento, con oltre 500 figure sales reclutate negli ultimi anni.",
        "Sul nostro database identifichiamo le figure commerciali coerenti con il tuo settore, il tuo mercato e il tuo modello di vendita, B2B, B2C, canale indiretto, agenti plurimandatari, key account. Solo nel segmento sales contiamo 670.000 profili verificati.",
        "Non cerchiamo \"un commerciale\". Cerchiamo la persona giusta per il tuo contesto specifico: un'azienda che vende a margine alto ha bisogno di qualcuno di diverso rispetto a una che punta sui volumi.",
        "Ogni candidato che ti presentiamo ha già parlato con un recruiter Lovac. Abbiamo valutato i risultati reali, non solo quelli dichiarati. Abbiamo capito la motivazione al cambio. Abbiamo verificato che il profilo sia coerente con quello che stai cercando.",
        "Tu incontri solo chi ha già superato questa fase.",
      ],
      ruoli_coperti: [
        "Agenti di commercio plurimandatari",
        "Sales Account · Key Account Manager",
        "Area Manager",
        "Direttore Commerciale",
        "Business Developer",
        "Sales Manager",
        "Commerciali interni e field",
        "Export Manager",
      ],
    },
    casi_studio_slugs: ["fotovoltora", "imori", "miras-energia"],
    hiring_scan: {
      title: "Quanto è difficile trovare il commerciale che cerchi?",
      subtitle:
        "Inserisci il ruolo, il settore e l'area geografica. Ottieni subito una stima del mercato: profili disponibili, RAL media e difficoltà di reperimento per quella figura specifica.",
    },
    cta_titolo: "Hai una posizione commerciale aperta da troppo tempo?",
  },

  manager: {
    key: "manager",
    label: "Manager · Middle management",
    short: "Manager",
    rich: true,
    category: "ruolo",
    hero_eyebrow: "Per chi è · Manager",
    seo_title: "Recruiting per Manager e Middle Management in Italia",
    meta_description:
      "Lovac trova manager e middle management anche non in ricerca attiva. Database di oltre 1 milione di profili manageriali verificati, selezione reale, primi candidati in 15 giorni.",
    subtitle:
      "Trovare un manager con le competenze giuste è tra le ricerche più difficili per una PMI italiana. Non perché i profili non esistano, perché quelli validi non sono disponibili.",
    market: {
      title: "Cosa dicono i numeri sul mercato dei manager in Italia.",
      intro:
        "La ricerca di figure manageriali è strutturalmente difficile in Italia. I dati lo confermano con chiarezza.",
      numbers: [
        {
          v: "62,4%",
          l: "Tasso di difficoltà nel reperire dirigenti e amministratori, unica categoria in crescita.",
          src: "Dati Excelsior, febbraio 2026, Unioncamere · Ministero del Lavoro · CNEL",
        },
        {
          v: "67%",
          l: "Imprese che dichiarano difficoltà nel trovare dirigenti.",
          src: "Manageritalia, Il futuro si gioca sulle competenze, 2025",
        },
        {
          v: "70%",
          l: "PMI italiane con difficoltà significative nel reperire personale qualificato.",
          src: "Institute of Applied Economic Research, agosto 2024, campione 981 PMI",
        },
      ],
      ral: {
        title: "RAL di mercato, dati Osservatorio JobPricing per Manageritalia (2024–2025)",
        rows: [
          { k: "Quadri · Middle management", v: "RAL media 56.746 €", note: "Picchi più alti in finance, energy e consumer goods" },
          { k: "Dirigenti", v: "RAL media 105.000–107.000 €", note: "Retribuzione totale (con variabili) fino a 120.000–140.000 €" },
          { k: "PMI", v: "Pacchetti più competitivi", note: "Per compensare il gap dimensionale rispetto alle grandi aziende" },
        ],
      },
    },
    problemi: {
      title: "Perché trovare un buon manager è così difficile.",
      blocks: [
        {
          title: "I manager validi non cercano lavoro",
          body:
            "Un manager con un track record solido è già occupato. Ha un ruolo, un team, responsabilità consolidate. Non sta mandando CV e non risponde agli annunci.\n\nSe stai aspettando che arrivi da solo, puoi aspettare a lungo. L'unico modo per raggiungerlo è andare a cercarlo, nel posto giusto, con il messaggio giusto, al momento giusto della sua traiettoria professionale.",
        },
        {
          title: "La valutazione è più complessa",
          body:
            "Selezionare un manager non è come selezionare un operativo. Bisogna valutare la capacità di gestire persone, prendere decisioni in condizioni di incertezza, costruire relazioni con stakeholder diversi.\n\nUn colloquio da solo non basta. Serve conoscere il mercato, capire la traiettoria del candidato, leggere la motivazione al cambio. E serve esperienza nel distinguere chi sa fare da chi sa presentarsi.",
        },
        {
          title: "Il costo di sbagliare è alto",
          body:
            "Un manager inserito nella posizione sbagliata o con aspettative non allineate costa molto di più della fee di selezione.\n\nCosta in termini di tempo perso, team disorientato, processi rallentati, e, nei casi peggiori, danni relazionali difficili da riparare. Prima di iniziare una ricerca, vale la pena lavorare bene sul profilo. Lovac lo fa con te.",
        },
      ],
    },
    metodo: {
      title: "Come troviamo manager che fanno davvero la differenza.",
      paragraphs: [
        "Sul nostro database di oltre 1.000.000 di profili manageriali verificati identifichiamo le figure più coerenti con il ruolo, il settore e il contesto organizzativo specifico della tua azienda.",
        "Non cerchiamo \"un manager\". Cerchiamo la persona giusta per la tua struttura: un'azienda in crescita ha bisogno di qualcuno di diverso rispetto a una realtà consolidata che deve ottimizzare.",
        "Ogni candidato che ti presentiamo ha già incontrato un recruiter Lovac in videocall. Abbiamo valutato il percorso reale, la capacità di gestione, la motivazione al cambio e la coerenza con il contesto che stai cercando di costruire.",
        "Per i profili più senior o in ambiti specifici, finance, operations, general management, il processo può prevedere colloqui aggiuntivi con specialisti di settore per valutare le competenze sul campo e non solo sulla carta.",
        "Tu incontri solo chi ha già superato questa fase.",
      ],
      ruoli_coperti: [
        "General Manager · Country Manager",
        "Operations Manager · Responsabile Operations",
        "Responsabile di funzione (HR, Finance, Marketing, Produzione)",
        "Plant Manager · Responsabile di stabilimento",
        "Project Manager senior",
        "Direttore Generale PMI",
        "Head of department",
        "Manager di transizione",
      ],
    },
    casi_studio_slugs: ["al-system", "fotovoltora"],
    hiring_scan: {
      title: "Quanto è difficile trovare il manager che cerchi?",
      subtitle:
        "Inserisci il ruolo, il settore e l'area geografica. Ottieni subito una stima del mercato: profili disponibili, RAL media e difficoltà di reperimento per quella figura specifica.",
    },
    cta_titolo: "Hai una posizione manageriale aperta?",
  },

  "tech-digitale": {
    key: "tech-digitale",
    label: "Tech · IT",
    short: "Tech",
    rich: true,
    hero_eyebrow: "Per chi è · Tech · IT",
    seo_title: "Recruiting per profili Tech e IT in Italia",
    meta_description:
      "Lovac trova sviluppatori, data analyst, IT manager e profili tech anche non in ricerca attiva. Database di 335.000 profili IT verificati, valutazione tecnica reale, primi candidati in 15 giorni.",
    subtitle:
      "Il mercato dei profili tech italiani è il più competitivo in assoluto. Le figure che cerchi ricevono già tre offerte prima di rispondere alla tua.",
    market: {
      title: "Cosa dicono i numeri sul mercato Tech e IT in Italia.",
      intro:
        "Il mercato dei profili tech è strutturalmente in deficit. La domanda cresce più velocemente dell'offerta e non accenna a rallentare.",
      numbers: [
        {
          v: "55.000",
          l: "Posizioni ICT che rischiano di rimanere scoperte nel 2025 per mancanza di candidati idonei.",
          src: "Excelsior Unioncamere, Competenze digitali 2025",
        },
        {
          v: "69%",
          l: "Difficoltà di reperimento per analisti e progettisti di software. Il 70,3% delle imprese segnala carenza di candidati.",
          src: "Excelsior Unioncamere 2024 · Arena Digitale",
        },
        {
          v: "76%",
          l: "Aziende italiane che riscontrano gravi difficoltà nel trovare competenze digitali specialistiche.",
          src: "Politecnico di Milano, HR Innovation Practice 2024",
        },
      ],
      ral: {
        title: "RAL di mercato, dati Glassdoor Italia 2026 · TechCompenso 2025",
        rows: [
          { k: "Senior Software Developer", v: "41.000 €", note: "RAL media, picchi a 85.000 € per Software Architect (fonte Glassdoor Italia 2026)" },
          { k: "Cybersecurity Analyst · 3–5 anni", v: "35.000–48.000 €", note: "Range mid/senior, TechCompenso 2025" },
          { k: "Data Scientist · Data Analyst", v: "oltre 50.000 €", note: "Profili senior tra i più richiesti dal mercato" },
          { k: "AI/ML · Cloud · Cybersecurity", v: "Sensibilmente più alti", note: "Specializzazioni che trattano pacchetti sopra la media" },
        ],
      },
    },
    problemi: {
      title: "Perché trovare profili Tech e IT è difficile anche per chi non è un'azienda tech.",
      blocks: [
        {
          title: "Competono con aziende che non puoi imitare",
          body:
            "Un buon sviluppatore senior o un data analyst con tre anni di esperienza riceve proposte costantemente. Spesso da aziende tech di scala internazionale, con pacchetti retributivi, flessibilità e stack tecnologici che una PMI non può replicare.\n\nLa sfida non è solo trovarlo, è convincerlo che il tuo progetto vale la pena del cambio. Serve sapere come presentare la tua azienda nel linguaggio giusto per questi profili.",
        },
        {
          title: "Valutare le competenze tecniche è complesso",
          body:
            "Mettere un annuncio e fare colloqui generici non basta. Per valutare davvero un profilo tech serve capire lo stack tecnologico, il livello reale di autonomia, la qualità del codice o dell'architettura.\n\nChi non ha competenze tecniche interne rischia di assumere figure che si presentano bene ma non producono quello che serve. Lovac affianca recruiter specializzati con una valutazione tecnica concreta.",
        },
        {
          title: "Il mercato si muove veloce",
          body:
            "I profili tech migliori non restano disponibili a lungo. Tra il momento in cui iniziano a valutare un cambio e quello in cui firmano un'offerta passano spesso poche settimane.\n\nUna ricerca lenta, con processi tradizionali, arriva tardi. Servono hunting attivo, contatto diretto e un processo di selezione che non perda tempo.",
        },
      ],
    },
    metodo: {
      title: "Come troviamo profili Tech e IT che funzionano davvero.",
      paragraphs: [
        "Sul nostro database di 335.000 profili tech e IT verificati identifichiamo le figure più coerenti con il ruolo, lo stack tecnologico e il contesto della tua azienda, che tu stia cercando uno sviluppatore, un data analyst, un IT manager o una figura di cybersecurity.",
        "Ogni candidato che ti presentiamo ha già incontrato un recruiter Lovac. Per le posizioni più tecniche, il processo prevede colloqui aggiuntivi con specialisti di settore per verificare le competenze reali e non solo quelle dichiarate sul CV.",
        "Sappiamo anche come presentare la tua azienda ai profili tech: cosa li muove, cosa guardano prima di valutare un'offerta, come rendere competitiva una proposta anche se non sei una software house.",
      ],
      ruoli_coperti: [
        "Software Developer · Engineer (frontend, backend, fullstack)",
        "Data Analyst · Data Scientist",
        "DevOps · Cloud Engineer",
        "IT Manager · CTO",
        "Cybersecurity Specialist · Analyst",
        "Product Manager · Product Owner",
        "UX/UI Designer",
        "Business Analyst",
        "Sistemista · Network Engineer",
        "AI/ML Engineer",
      ],
    },
    casi_studio_slugs: ["fotovoltora", "chs-group", "al-system"],
    hiring_scan: {
      title: "Quanto è difficile trovare il profilo Tech / IT che cerchi?",
      subtitle:
        "Inserisci il ruolo, lo stack e l'area geografica. Ottieni subito una stima del mercato: profili disponibili, RAL media e difficulty score per quella figura specifica.",
    },
    cta_titolo: "Stai cercando talenti in ambito Tech o IT?",
  },

  "finance-amministrazione": {
    key: "finance-amministrazione",
    label: "Finance · Amministrazione",
    short: "Finance",
    rich: true,
    hero_eyebrow: "Per chi è · Finance",
    seo_title: "Recruiting per profili Finance e Amministrazione in Italia",
    meta_description:
      "Lovac trova CFO, controller, responsabili amministrativi e figure finance anche non in ricerca attiva. Database di 428.000 profili verificati, selezione reale, primi candidati in 15 giorni.",
    subtitle:
      "CFO, controller, responsabili amministrativi: figure che le aziende cercano a lungo e che raramente si trovano sui portali.",
    market: {
      title: "Cosa dicono i numeri sul mercato finance in Italia.",
      intro:
        "Il mercato dei profili finance e amministrativi è tra i più competitivi per le PMI italiane. Le figure con esperienza reale sono poche, molto richieste e raramente disponibili.",
      numbers: [
        {
          v: "50,5%",
          l: "Quota di assunzioni con difficoltà di reperimento per micro e piccole imprese italiane.",
          src: "Confartigianato Imprese su dati Excelsior Unioncamere, 2025",
        },
        {
          v: "1 su 2",
          l: "Le figure finance e controllo di gestione rientrano tra le più difficili da reperire in tutte le classi dimensionali.",
          src: "Excelsior Unioncamere 2025",
        },
        {
          v: "PMI",
          l: "Domanda crescente per CFO, Controller e Responsabili AFC nelle aziende in fase di strutturazione o espansione.",
          src: "PageGroup Salary Survey 2025",
        },
      ],
      ral: {
        title: "RAL di mercato, dati Michael Page Finance Salary Survey 2025 · Indeed Italia 2026",
        rows: [
          { k: "CFO · 5–10 anni", v: "95.000–130.000 €", note: "Punte oltre i 130.000 € per profili con più di 10 anni di esperienza" },
          { k: "Responsabile Amministrativo · Finanziario", v: "45.000–55.000 €", note: "Variazioni significative per settore e dimensione aziendale" },
          { k: "Financial Controller · 5–10 anni", v: "42.500–55.000 €", note: "Responsabile Controllo di Gestione, fascia mid/senior" },
          { k: "Responsabile Tesoreria · 5–10 anni", v: "55.000–70.000 €", note: "Profili con responsabilità diretta sui flussi finanziari" },
        ],
      },
    },
    problemi: {
      title: "Perché trovare profili finance qualificati è così difficile.",
      blocks: [
        {
          title: "I profili validi non cercano lavoro",
          body:
            "Un controller o un responsabile amministrativo con un track record solido è già inserito in un contesto che lo valorizza. Non sta esplorando portali, non risponde agli annunci.\n\nIl mercato dei profili finance di qualità è quasi interamente fatto di persone occupate. Raggiungerli richiede un approccio diretto, non un annuncio pubblicato e dimenticato.",
        },
        {
          title: "La valutazione richiede competenza specifica",
          body:
            "Valutare un profilo finance non è semplice per chi non ha familiarità con le competenze tecniche del ruolo. La differenza tra chi sa fare il controllo di gestione e chi lo descrive bene in un colloquio non è sempre evidente al primo incontro.\n\nServe esperienza nel settore per capire se una traiettoria è coerente, se i numeri dichiarati reggono a un approfondimento, se la persona è pronta per il contesto in cui andrà a lavorare.",
        },
        {
          title: "Le PMI competono con aziende più strutturate",
          body:
            "I profili finance senior ricevono proposte da grandi aziende con pacchetti retributivi, benefit e percorsi di carriera che una PMI fa fatica a replicare.\n\nPer attrarre queste figure serve sapere come posizionare l'offerta: più responsabilità, più impatto diretto, più velocità di crescita. Argomenti che funzionano, ma che vanno comunicati nel modo giusto, al momento giusto.",
        },
      ],
    },
    metodo: {
      title: "Come troviamo profili finance che fanno la differenza.",
      paragraphs: [
        "Sul nostro database di 428.000 profili finance e amministrativi verificati identifichiamo le figure più coerenti con il ruolo, il settore e la fase di sviluppo della tua azienda, che tu stia cercando un CFO, un controller, un responsabile amministrativo o una figura di tesoreria.",
        "Ogni candidato che ti presentiamo ha già incontrato un recruiter Lovac. Abbiamo valutato le competenze tecniche, la traiettoria professionale, la motivazione al cambio e la coerenza con il contesto che stai cercando di costruire.",
        "Per i profili più senior, CFO, Direttore Amministrativo, Responsabile AFC, il processo può prevedere colloqui aggiuntivi con specialisti di settore per verificare le competenze sul campo.",
        "Tu incontri solo chi ha già superato questa fase.",
      ],
      ruoli_coperti: [
        "CFO · Direttore Amministrativo e Finanziario",
        "Responsabile Amministrativo e Finanziario (RAF)",
        "Financial Controller · Controller Industriale",
        "Responsabile Controllo di Gestione",
        "Responsabile Tesoreria",
        "Responsabile Contabilità · Chief Accountant",
        "Tax Manager · Responsabile Fiscale",
        "Internal Auditor",
        "FP&A Manager (Financial Planning & Analysis)",
        "Credit Manager",
      ],
    },
    casi_studio_slugs: ["al-system", "ramitours", "svezia-auto"],
    hiring_scan: {
      title: "Quanto è difficile trovare il profilo finance che cerchi?",
      subtitle:
        "Inserisci il ruolo, il settore e l'area geografica. Ottieni subito una stima del mercato: profili disponibili, RAL media e difficoltà di reperimento per quella figura specifica.",
    },
    cta_titolo: "Stai cercando un profilo finance per la tua azienda?",
  },

  "senior-specialist": {
    key: "senior-specialist",
    label: "Senior Specialist",
    short: "Senior Specialist",
    rich: true,
    category: "ruolo",
    hero_eyebrow: "Per chi è · Senior Specialist",
    seo_title: "Recruiting per Senior Specialist e Profili Qualificati in Italia",
    meta_description:
      "Lovac trova senior specialist e profili qualificati anche non in ricerca attiva. Database di 877.000 profili senior verificati, valutazione tecnica reale, primi candidati in 15 giorni.",
    subtitle:
      "I professionisti con esperienza verticale profonda sono i più difficili da trovare e i più difficili da convincere. Non aspettano il tuo annuncio.",
    market: {
      title: "Cosa dicono i numeri sul mercato dei profili qualificati in Italia.",
      intro:
        "La difficoltà di reperire profili esperti e qualificati è una delle sfide strutturali del mercato del lavoro italiano. I dati lo confermano.",
      numbers: [
        {
          v: "86%+",
          l: "Difficoltà di reperimento per le professioni tecniche e altamente qualificate in cima alla graduatoria.",
          src: "Rapporto Excelsior Unioncamere 2024",
        },
        {
          v: "48%",
          l: "Difficoltà di reperimento del personale in Italia nel 2024 (cresciuta dal 45% del 2023). Punte oltre il 60% per ingegneri e tecnici specializzati.",
          src: "Excelsior Unioncamere 2024",
        },
        {
          v: "Mismatch",
          l: "La carenza è in crescita per tendenze demografiche e disallineamento tra formazione e competenze richieste dal mercato.",
          src: "Excelsior Unioncamere 2024",
        },
      ],
      ral: {
        title: "RAL di mercato, dati Talent.com Italia 2026 · benchmark di settore",
        rows: [
          { k: "Ingegneria · Senior", v: "42.000–65.000 €", note: "Punte oltre i 75.000 € per specializzazioni rare" },
          { k: "Finance · Banche · Assicurazioni", v: "60.000–80.000 €", note: "Profili senior con esperienza verticale" },
          { k: "Tecnici altamente qualificati", v: "45.000–75.000 €", note: "Operations · Supply Chain · R&D, varia per settore" },
          { k: "Profili bilingui · International", v: "Sopra la media", note: "Pacchetti sensibilmente più alti per esperienza estera" },
        ],
      },
    },
    problemi: {
      title: "Perché trovare un senior specialist è così diverso da qualsiasi altra ricerca.",
      blocks: [
        {
          title: "Sono introvabili perché non cercano",
          body:
            "Un senior specialist con 8–10 anni di esperienza verticale profonda ha costruito una reputazione, un network, una posizione. Non sta esplorando portali di lavoro nel tempo libero.\n\nSe ti aspetti che arrivi da solo, aspetti invano. L'unico modo per raggiungerlo è sapere dove cercarlo, come approcciarlo e cosa offrirgli che valga il rischio di un cambio.",
        },
        {
          title: "La valutazione richiede competenza specifica",
          body:
            "Valutare un senior specialist richiede di capire davvero il dominio in cui opera. Un colloquio generico non basta per distinguere chi ha esperienza reale da chi ha un CV curato.\n\nPer certi profili, tecnici, R&D, operations, supply chain, legale, regolatorio, la profondità della conoscenza si vede solo se sai cosa stai cercando.",
        },
        {
          title: "Il mercato si muove in ambienti ristretti",
          body:
            "I migliori senior specialist si conoscono tra loro. Si spostano per referral, per reputazione, per progetti interessanti, non per annunci pubblici.\n\nIntercettarli significa avere accesso a quell'ambiente. Un database da 877.000 profili qualificati verificati è un punto di partenza. Il recruiter che sa come approcciarli è quello che fa la differenza.",
        },
      ],
    },
    metodo: {
      title: "Come troviamo senior specialist che non troveresti da nessun'altra parte.",
      paragraphs: [
        "Sul nostro database di 877.000 profili senior e qualificati verificati identifichiamo le figure più coerenti con il ruolo, il settore e il livello di specializzazione che stai cercando.",
        "Non cerchiamo \"un esperto\". Cerchiamo la persona giusta per il tuo contesto specifico: un'azienda in espansione ha bisogno di qualcuno di diverso rispetto a una realtà che deve consolidare o ristrutturare una funzione.",
        "Per i profili più tecnici o con competenze altamente verticali, il processo può prevedere colloqui aggiuntivi con specialisti di settore per verificare la profondità reale delle competenze, non solo quelle dichiarate sul CV.",
        "Ogni candidato che ti presentiamo ha già incontrato un recruiter Lovac. Sappiamo perché sta valutando un cambio, cosa cerca in una nuova opportunità e se il tuo contesto può essere la risposta giusta.",
      ],
      ruoli_coperti: [
        "Senior Engineer · Technical Lead",
        "Responsabile R&D · Innovation Manager",
        "Supply Chain Manager · Operations Specialist",
        "Regulatory Affairs Specialist",
        "Senior Legal Counsel · Responsabile Legale",
        "HSE Manager · Quality Manager",
        "Responsabile Acquisti · Procurement Specialist",
        "Senior Marketing Manager · Brand Manager",
        "Specialista HR senior · Talent Acquisition Lead",
        "Qualsiasi figura con 8+ anni di esperienza verticale",
      ],
    },
    casi_studio_slugs: ["al-system", "giemme-porte-finestre", "ramitours"],
    hiring_scan: {
      title: "Quanto è difficile trovare il profilo qualificato che cerchi?",
      subtitle:
        "Inserisci il ruolo, il settore e l'area geografica. Ottieni subito una stima del mercato: profili disponibili, RAL media e difficoltà di reperimento per quella figura specifica.",
    },
    cta_titolo: "Stai cercando un profilo con esperienza verticale profonda?",
  },

  "ceo-c-level": {
    key: "ceo-c-level",
    label: "CEO · C-level",
    short: "CEO · C-level",
    rich: true,
    category: "ruolo",
    hero_eyebrow: "Per chi è · CEO · C-Level",
    seo_title: "Recruiting per CEO e figure C-Level in Italia",
    meta_description:
      "Lovac trova CEO, General Manager e figure C-Level anche non in ricerca attiva. Database di 201.000 profili dirigenziali verificati, processo riservato, approccio diretto.",
    subtitle:
      "Trovare la persona giusta per guidare un'azienda è la ricerca più delicata che esista. Non si fa con un annuncio.",
    market: {
      title: "Cosa dicono i numeri sul mercato dei profili C-Level in Italia.",
      intro:
        "La ricerca di figure C-Level è la più complessa e la più critica per qualsiasi azienda. I dati lo confermano.",
      numbers: [
        {
          v: "67,8%",
          l: "Imprese italiane con ricerche in corso che dichiarano difficoltà di reperimento, dato strutturale, non congiunturale.",
          src: "Confindustria, Indagine sul lavoro 2025",
        },
        {
          v: "78%",
          l: "Aziende italiane che dichiarano di faticare a trovare competenze adeguate. Profili di leadership e C-Level tra le categorie più difficili.",
          src: "ManpowerGroup Talent Shortage Report · febbraio 2026",
        },
        {
          v: "106.600 €",
          l: "RAL media dirigenti in Italia. Il 9° decile dei CEO guadagna 8,8 volte rispetto al 1° decile degli operai.",
          src: "JP Salary Outlook 2026, Osservatorio JobPricing",
        },
      ],
      ral: {
        title: "RAL di mercato, dati Glassdoor Italia 2025 · Unipegaso · JobPricing 2026",
        rows: [
          { k: "General Manager · Direttore Generale", v: "100.000–130.000 €", note: "RAL base privato, variabile fino al 20% al raggiungimento degli obiettivi" },
          { k: "CEO PMI · 50–250 dipendenti", v: "47.500–97.375 €", note: "Punte significativamente più alte in base a settore e dimensione" },
          { k: "Dirigenti · RAL media Italia", v: "106.600 €", note: "9° decile CEO: 8,8× il 1° decile degli operai" },
          { k: "Bonus · Variabile · LTI", v: "20%+ sulla RAL", note: "Pacchetti totali significativamente superiori per profili apicali" },
        ],
      },
    },
    problemi: {
      title: "Perché trovare un CEO o un C-Level è la ricerca più difficile che farai.",
      blocks: [
        {
          title: "Non esiste un mercato pubblico per queste figure",
          body:
            "I CEO e i C-Level che funzionano davvero non sono su LinkedIn a segnalare \"open to work\". Sono già al lavoro, con responsabilità, risultati e un network che li protegge da chiamate indesiderate.\n\nL'unico modo per raggiungerli è attraverso una rete di relazioni qualificate e un approccio diretto, riservato e calibrato. Non con un annuncio pubblico.",
        },
        {
          title: "L'errore costa moltissimo",
          body:
            "Sbagliare una figura operativa è costoso. Sbagliare un CEO o un C-Level può cambiare le sorti di un'azienda.\n\nUn inserimento sbagliato a questo livello non impatta solo sul budget, impatta sulla cultura aziendale, sul team, sulla fiducia degli stakeholder, e in alcuni casi sulla continuità del business. La valutazione deve essere profonda, riservata e condotta da chi ha esperienza su questo tipo di figure.",
        },
        {
          title: "Richiede riservatezza totale",
          body:
            "Le ricerche C-Level spesso non possono essere pubbliche. Un'azienda che cerca un nuovo CEO non può farlo sapere ai dipendenti, ai clienti, ai concorrenti.\n\nLa gestione della riservatezza, nella comunicazione con i candidati, nella gestione del processo, nella tempistica, è parte integrante del lavoro. Non è un dettaglio operativo. È un requisito.",
        },
      ],
    },
    metodo: {
      title: "Come troviamo i profili che guidano le aziende.",
      paragraphs: [
        "Sul nostro database di 201.000 profili C-Level e dirigenziali verificati identifichiamo le figure più coerenti con il ruolo, il contesto aziendale, la fase di sviluppo e la cultura dell'organizzazione che stai cercando di costruire o rafforzare.",
        "Non cerchiamo \"un CEO\". Cerchiamo la persona giusta per la tua specifica situazione: un'azienda in crescita accelerata ha bisogno di qualcuno di diverso rispetto a una realtà in fase di consolidamento o ristrutturazione.",
        "Il processo è riservato per definizione. Il recruiter dedicato gestisce i contatti in modo discreto, con comunicazioni calibrate e timing definiti insieme al cliente. Nessuna informazione viene condivisa con il candidato prima che il cliente lo abbia approvato.",
        "Per questo livello di profilo, il processo prevede sempre colloqui approfonditi, non solo sul percorso professionale, ma su visione, stile di leadership, gestione delle situazioni complesse e coerenza con il contesto in cui andrà a operare.",
      ],
      ruoli_coperti: [
        "CEO · Amministratore Delegato",
        "General Manager · Direttore Generale",
        "COO · Chief Operating Officer",
        "CFO · Chief Financial Officer",
        "CTO · Chief Technology Officer",
        "CMO · Chief Marketing Officer",
        "Country Manager",
        "Managing Director",
        "Presidente Esecutivo",
        "Partner · Co-founder operativo",
      ],
    },
    casi_studio_slugs: ["al-system", "fotovoltora", "imori"],
    hiring_scan: {
      title: "Vuoi capire il mercato prima di aprire la ricerca?",
      subtitle:
        "Inserisci il ruolo, il settore e l'area geografica. Ottieni una stima del mercato: profili disponibili, RAL media e difficoltà di reperimento per quella figura specifica.",
    },
    cta_titolo: "Stai cercando la figura che guiderà la tua azienda?",
  },
};

export const VERTICAL_LIST = Object.values(VERTICALS);
export const VERTICAL_REPARTI = VERTICAL_LIST.filter((v) => v.category !== "ruolo");
